export const ClientsTrackingPermissions = {
  ViewClientTracking: {
    permissionsId: "63528373-fe7a-4805-b6e8-08dd8b9e8c29",
    permissionsName: "View Client Tracking",
    description: null,
    componentsId: null,
    components: null,
  },
};
